module.exports = __webpack_public_path__ + "img/switch-map.f04dd5aa.svg";